export const PALETTE = {
  SUCCESS: "#06A561",
  WARNING: "orange",
};
